<template>
	<div class="step-wrapper">
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step3.message1')"/>
		<div class="link-message" v-html="t('payments.batchfile.newPayment.helperModal.step3.message2')" @click="emit('helperStepUpdate', 6)"/>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step3.message3')"/>
	</div>
</template>

<script setup>
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['helperStepUpdate'])
</script>

<style lang="scss" scoped>
.step-wrapper {
	width: 100%;
	padding-bottom: 56px;

	display: flex;
	flex-direction: column;
	color: var(--secondary-dark-2);
	.step-message {
		@include H7-Regular;
        line-height: 16px;
		word-wrap: break-word;
	}

	.link-message {
		@include H7-Medium;
		line-height: 16px;
		word-wrap: break-word;
		text-decoration: underline;

		margin-bottom: 24px;

		cursor: pointer;
	}
}
</style>
